import { useState } from 'react';
import Switch from '@/components/primitives/Switch.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import setAutomationActive from '../lib/setAutomationActive.js';

/** Turns an automation on or off right away. The switch follows the saved state, so a failed save flips back. */
const AutomationActiveSwitch = ({ automation }) => {
  const [saving, setSaving] = useState(false);

  const handleChange = async (active) => {
    setSaving(true);
    const result = await setAutomationActive({ kind: automation.kind, id: automation.id, active });
    setSaving(false);

    if (result?.success === false) {
      toastManager.add({ title: active ? 'Could not turn it on' : 'Could not turn it off', description: result.message || 'Try again in a moment.', type: 'error' });
      return;
    }

    toastManager.add({ title: active ? `${automation.name} is on` : `${automation.name} is off`, description: active ? 'It runs on its own from now on.' : 'It will not run until you turn it on.', type: 'success' });
  };

  return <Switch label={automation.active ? 'On' : 'Off'} checked={automation.active} onCheckedChange={handleChange} disabled={saving || automation.isPlanning} />;
};

export default AutomationActiveSwitch;
